import * as React from 'react';
import { dashboard } from 'types';
import { getName } from 'utils/partyUtils';
import GuestAndVisitIcons from 'components/crm/GuestAndVisitIcons';

export interface Props {
  item: dashboard.CalendarWaitlist;
  onClick(id: number): void;
  showNotes: boolean;
}

const NotifyListParty: React.FunctionComponent<React.PropsWithChildren<Props>> = ({
  onClick,
  item,
  showNotes,
}) => {
  const MAX_ICONS_TO_DISPLAY = 3;

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if (item.id) {
      onClick(item.id);
    }
  };

  const patron = item?.guestProfile?.patron;
  const hasNote = item.note ? true : false;

  return (
    <a className="NotifyListParty" onClick={handleClick}>
      <div className="PartyBodyCondensed-title">
        <span className="PartyBodyCondensed-name">
          {getName(
            patron?.firstName ? patron?.firstName : '',
            patron?.lastName ? patron?.lastName : '',
            patron?.email ? patron?.email : ''
          )}
        </span>
        <span className="PartyBodyCondensed-size">{item.desiredSize}</span>
      </div>
      <div className="PartyBodyCondensed-description">
        <div
          className="PartyBodyCondensed-experience NotifyListParty-experience showMore"
          data-for="tooltip"
          data-tip="Reservation"
        >
          <span>
            {item?.desiredExperience?.shortCode ? item?.desiredExperience?.shortCode : 'ANY'}
          </span>
        </div>

        <GuestAndVisitIcons
          guestProfile={item.guestProfile as dashboard.GuestProfile}
          visitTags={[]}
          hasQuickNote={hasNote}
          hasVisitNote={!!item.guestNote}
          hasVisitDietaryNote={false}
          hasPaymentRequired={false}
          hasNewMessage={false}
          hasAnsweredQuestion={false}
          hasPurchasedSupplements={false}
          maxIconsToDisplay={MAX_ICONS_TO_DISPLAY}
        />
      </div>
      {showNotes && (
        <>
          <div className={`PartyBodyCondensed-notes ${!item.note ? 'is-empty' : ''}`}>
            {item.note || 'Add Note...'}
          </div>
        </>
      )}
    </a>
  );
};

export default NotifyListParty;
